import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import SlidePanel from "../../components/SlidePanel/SlidePanel";
import AppDropdown from "../../components/AppDropdown/AppDropdown";
import * as hrmsService from "../../services/hrmsService";
import { Field, PrimaryButton, SecondaryButton } from "./hrComponents";
import { inputStyle, todayYmd } from "./hrUi";

// LEV-08: claim compensatory off for a weekly off or holiday that was worked.
export default function CompOffDrawer({ show, onHide, onDone }) {
  const [date, setDate] = useState(todayYmd());
  const [days, setDays] = useState(1);
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setDate(todayYmd());
      setDays(1);
      setReason("");
    }
  }, [show]);

  const submit = async () => {
    setSaving(true);
    try {
      const res = await hrmsService.claimCompOff({ worked_date: date, days, reason: reason.trim() || undefined });
      if (res?.success) {
        toast.success(res.message || "Comp-off claim sent");
        onDone && onDone();
        onHide();
      } else toast.error(hrmsService.responseMessage(res));
    } finally {
      setSaving(false);
    }
  };

  return (
    <SlidePanel
      show={show}
      onHide={() => !saving && onHide()}
      title="Claim comp-off"
      footer={
        <>
          <SecondaryButton onClick={onHide} disabled={saving}>
            Cancel
          </SecondaryButton>
          <PrimaryButton onClick={submit} disabled={saving || !date}>
            Submit
          </PrimaryButton>
        </>
      }
    >
      <Field label="Day you worked" required hint="A weekly off or holiday, within the last 60 days">
        <input type="date" className="form-control" style={inputStyle} value={date} max={todayYmd()} onChange={(e) => setDate(e.target.value)} />
      </Field>
      <Field label="Days">
        <AppDropdown
          value={days}
          options={[
            { label: "Full day", value: 1 },
            { label: "Half day", value: 0.5 },
          ]}
          onChange={(e) => setDays(e.value)}
        />
      </Field>
      <Field label="Reason">
        <textarea className="form-control" rows={3} maxLength={500} value={reason} onChange={(e) => setReason(e.target.value)} />
      </Field>
    </SlidePanel>
  );
}
